module.exports = __webpack_public_path__ + "assets/jiaoxuelou.c9907af7.svg";